import { Typography, TypographyProps } from '@mui/material';

import { Constants } from '@arrived/common';

export type CellBodyTypographyProps = TypographyProps;

export const CellBodyTypography = (props: CellBodyTypographyProps) => {
  return <Typography variant="body1" color={({ palette }) => palette.neutrals.gray} {...props} />;
};
